import React from "react";
import moment from "moment";

export default function StudentCoursesTableRow(props) {
  const {
    course: {
      courseScheduleName,
      didCompleteAttendance,
      didCompleteSurvey,
      firstClassDate,
      numOfClasses,
      numOfClassesAttended,
      studentCourseScheduleEnrollmentStatus,
      surveyDeadline,
    },
    studentEnrollmentStatus,
    onMarkReviewCompleted,
    removeCourseEnrollment,
    viewOnly,
  } = props;

  const canMarkReviewCompleted =
    !viewOnly &&
    studentEnrollmentStatus !== "Rejected" &&
    studentEnrollmentStatus !== "Pending" &&
    studentCourseScheduleEnrollmentStatus !== "Pending" &&
    studentCourseScheduleEnrollmentStatus !== "Ineligible" &&
    didCompleteAttendance;

  return (
    <div className="students-courses-history-table-row">
      <p>{courseScheduleName}</p>
      <p>{firstClassDate ? moment(firstClassDate).format("MM/DD/YYYY") : ""}</p>
      <p>{`${Math.max(numOfClassesAttended, 0)}/${numOfClasses}`}</p>
      <p>
        {studentEnrollmentStatus === "Rejected"
          ? "N/A"
          : studentCourseScheduleEnrollmentStatus}
      </p>
      <p className="flex flex-align-center">
        {didCompleteSurvey ? (
          "Yes"
        ) : (
          <>
            No
            {canMarkReviewCompleted && (
              <i
                className="material-icons large-text ml-8"
                onClick={onMarkReviewCompleted}
                style={{ cursor: "pointer", color: "green" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "gray")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "green")}
                title="Mark review as completed"
              >
                check_circle_outline
              </i>
            )}
          </>
        )}
      </p>
      <p
        className={
          !didCompleteSurvey && moment().isAfter(surveyDeadline)
            ? "error-text"
            : ""
        }
      >
        {surveyDeadline ? moment(surveyDeadline).format("MM/DD/YYYY") : ""}
      </p>
      <p>
        {!viewOnly && (
          <i
            className="link-text-secondary material-icons medium-text"
            onClick={removeCourseEnrollment}
            style={{ padding: "8px" }}
          >
            delete
          </i>
        )}
      </p>
    </div>
  );
}
